import * as React from 'react'
import * as Loadable from 'react-loadable'
import LoadingComponentProps = LoadableExport.LoadingComponentProps
import Loader from '../elements/Loader'
import Reload from '../pages/Reload'
import { getRandomColor } from '../utils/colour'

const Loading: React.FC<LoadingComponentProps> = ({ error, pastDelay }) => {
  if (error) {
    return <Reload />
  } else if (pastDelay) {
    return <Loader colour={getRandomColor()} />
  } else {
    return null
  }
}

export function loadable(loader: () => any) {
  return Loadable({
    loader,
    loading: Loading,
    delay: 300,
  })
}
